export function processRecords(records) {
  const categorizedRecords = {};

  records.forEach((record) => {
    const category = record.category;
    if (!categorizedRecords[category]) {
      categorizedRecords[category] = [];
    }

    const elements = [record.title, record.price, record.time, record.details];

    elements[3] = elements[3]
      .join('.')
      .split('.')
      .map((line) => (line.trim().length > 0 ? `${line} ✔` : line))
      .join('<br/>');

    categorizedRecords[category].push(elements);
  });

  return categorizedRecords;
}